import React, { memo, useCallback } from 'react';
import { CopyButton, CopyIcon } from '../styles';
import { handleCopyLeadToClipBoard } from '../handlers';

export const CopyLeadButton = memo(({ item }) => {
  const handleCopy = useCallback((event) => {
    handleCopyLeadToClipBoard(event, item);
  }, [item]);

  return (
    <CopyButton onClick={handleCopy}>
      <CopyIcon />
    </CopyButton>
  );
});

CopyLeadButton.displayName = 'CopyLeadButton';